<template>
  <div class="container px-3">
    <div class="not-found d-flex flex-column text-center pb-5 pt-5">
      <div class="image-wrapper">
        <img src="@/assets/icon/empty.png" alt="">
      </div>
      <p class="text-title-active fw-bold fs-18 lh-28">
        Halaman tidak ditemukan
      </p>
      <div class="text-body-light d-flex justify-content-center">
        <p class="fw-400 fs-14 lh-24 mb-0">Maaf, halaman yang anda cari tidak tersedia.</p>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <router-link to="/" class="btn btn-primary">Kembali ke Beranda</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick, onMounted } from '@vue/runtime-core'
import { title } from '@/core/page'

export default {
  setup () {
    onMounted(() => {
      nextTick(() => {
        title.value = 'Halaman Tidak Ditemukan'
      })
    })
  }
}
</script>

<style lang="scss" scoped>
.not-found {
  .image-wrapper {
    margin-bottom: 24px;
  }

  .text-title-active {
    margin-bottom: 4px;
  }

  .text-body-light p {
    width: 192px;
  }
}
</style>
